import {
  Component, OnInit, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef,
  HostListener,
  Input
} from '@angular/core';
import { takeUntil, Subject } from 'rxjs';

import { SideBarState } from '@app/views/themes/default-theme/models';
import { NavigationService } from '@app/core/services/navigation.service';
import { SupportSidebarService } from '@app/core/services';
import { SupportSideBarTabs } from '@app/core/types';
import { RequestStatus } from '@app/shared/types';
import { HelpDeskContentType } from '@app/shared/components/help-desk/types/help-desk-content-type';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RequestMessageComponent } from './request-message/request-message.component';
import { HelpDeskComponent } from '@app/shared/components/help-desk/help-desk.component';
import {MatTabsModule} from '@angular/material/tabs';
import { ERequestStatusCryptoWithdrawTextType } from '@app/views/pages/deposit/history/digital-currency-crypto/types/crypto-request-status.type';

@Component({
    selector: 'tc-request-sidebar-edit',
    imports: [
        TranslateModule,
        CommonModule,
        RequestMessageComponent,
        HelpDeskComponent,
        MatTabsModule
    ],
    templateUrl: './request-sidebar-edit.component.html',
    styleUrls: ['./request-sidebar-edit.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestSidebarEditComponent implements OnInit {

  @Output() isRequestSidebarOpenEmit = new EventEmitter<boolean>();
  @Input() requestStatus: RequestStatus | ERequestStatusCryptoWithdrawTextType;
  @Input() requestId: string;
  @Input() helpDeskContentType: HelpDeskContentType;
  @Input() isCryptoWithdraw: boolean = false;

  unsubscribeAll$ = new Subject<void>();

  // boolean
  showHelp: boolean;
  hide = true;
  isSideBarLocked: boolean;

  // style
  width: string;
  sidebarState: SideBarState;
  requestSidebarState = '0';

  tabSelectedIndex = 0;

  constructor(
    private cdRef: ChangeDetectorRef,
    private navigationService: NavigationService,
    private supportTabsService: SupportSidebarService
  ) { }

  ngOnInit() {
    this.manageStyles();
    this.setStyles();
    this.manageActiveTabIndex();
    setTimeout(() => {
      this.hide = false;
    }, 500);
    this.tabSelectedIndex = 1;
  }
  manageActiveTabIndex(): void {
    this.supportTabsService
      .activeTab$
      .pipe(
        takeUntil(this.unsubscribeAll$)
      ).subscribe(
        res => {
          if (res === SupportSideBarTabs.Help) {
            this.tabSelectedIndex = 0;
          } else {
            this.tabSelectedIndex = 1;
          }
        }
      );
    if (
      this.requestStatus === RequestStatus.NEW ||
      this.requestStatus === RequestStatus.PROCESSING ||
      this.requestStatus === RequestStatus.PAYMENT ||
      this.requestStatus === ERequestStatusCryptoWithdrawTextType.New ||
      this.requestStatus === ERequestStatusCryptoWithdrawTextType.Processing ||
      this.requestStatus === ERequestStatusCryptoWithdrawTextType.AwatingApproval ||
      this.requestStatus === ERequestStatusCryptoWithdrawTextType.Scheduled
    ) {
      this.showHelp = true;
    } else {
      this.showHelp = false;
      if (window.innerWidth < 992 && !this.isSideBarLocked) {
        this.isRequestSidebarOpenEmit.emit(false);
      }
    }
  }



  closeSideBarInModalMode(element: any): void {
    if (window.innerWidth < 992) {
      this.close();
    }
  }

  onSidebarLockedChange(isLocked: boolean): void {
    this.isSideBarLocked = isLocked;
  }


  close() {
    this.requestSidebarState = '0';
    this.isRequestSidebarOpenEmit.emit(false);
  }
  manageStyles(): void {
    this.navigationService.toggleSidebar$.subscribe(
      (state) => {
        this.sidebarState = state;
        this.setStyles();
      }
    );
  }
  setStyles(): void {
    let percent = '';
    let minusPixel = '';
    const menuIsClose = this.sidebarState === 'close';
    if (window.innerWidth > 1500) {
      percent = '25%';
      minusPixel = (menuIsClose) ? '25px' : '75px';
    } else if (window.innerWidth > 1200 && window.innerWidth <= 1500) {
      percent = '29%';
      minusPixel = (menuIsClose) ? '30px' : '85px';
    } else {
      percent = '39%';
    }
    this.width = `calc(${percent} - ${minusPixel})`;
    this.cdRef.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setStyles();
    if (window.innerWidth < 992 && !this.isSideBarLocked) {
      this.isRequestSidebarOpenEmit.emit(false);
    }

  }
}
